import { NgModule } from "@angular/core";
import { ButtonCardComponent } from "./button-card.component";
import { MatIconModule } from "@angular/material/icon";
import { CommonModule } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";

@NgModule({
    imports: [MatIconModule, CommonModule, MatTooltipModule],
    declarations: [ButtonCardComponent],
    exports: [ButtonCardComponent],
})
export class ButtonCardModule {}
